import React from "react";
import "./ConformPopUp.scss";
import CustomButton from "../../components/CustomButton";

const ConformPopUp = ({
  description = "Are you sure!",
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  customClass,
}) => {
  const handleClick = (e) => {
    const { className } = e.target;
    if (className === "ConformPopUp") {
      onCancel();
    }
  };
  return (
    <div className="ConformPopUp" onClick={handleClick}>
      <div className={`ConformPopUp__content_container ${customClass}`}>
        <p className="popup_title">{description}</p>
        <div className="btn_wrapper">
          <CustomButton
            type="delete"
            value={cancelText}
            onClick={onCancel && onCancel}
          />
          <CustomButton
            type="add"
            value={confirmText}
            onClick={onConfirm && onConfirm}
          />
        </div>
      </div>
    </div>
  );
};

export default ConformPopUp;
